<script setup lang="ts">
import AnimatedPun from './AnimatedPun.vue';
import { useAirBulletin } from '../composables/useAirBulletin';
const {
  previousDesign,
  currentTier,
  currentPun,
  isLoading,
  punBadge,
  shufflePun,
  openShareCardModal,
} = useAirBulletin();
</script>

<template>
  <component
    :is="previousDesign ? 'article' : 'section'"
    class="pun-feature"
    :aria-labelledby="previousDesign ? 'pun-text' : 'pun-heading'"
    aria-live="polite"
    aria-atomic="true"
  >
    <div class="pun-feature-top">
      <span class="pun-label">{{
        previousDesign ? "TODAY'S HEADLINE" : 'A LITTLE COMIC RELIEF'
      }}</span>
      <span v-if="currentTier" class="pun-severity" :data-tier="currentTier.id">{{
        currentTier.name
      }}</span>
      <span v-else class="pun-severity pending">{{
        isLoading ? 'READING AIR' : 'NO LIVE READING'
      }}</span>
    </div>
    <AnimatedPun
      :heading-id="previousDesign ? 'pun-text' : 'pun-heading'"
      :text="currentPun.text"
    />
    <div class="pun-feature-bottom">
      <span class="pun-byline">{{ punBadge }}</span>
      <div class="pun-actions">
        <button
          id="shuffle-pun-btn"
          class="button button-primary"
          type="button"
          title="Generate another pun (Spacebar)"
          :disabled="!currentTier"
          @click="shufflePun()"
        >
          Another pun
          <svg class="action-icon" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M20 7v5h-5M4 17v-5h5M6 7a7 7 0 0 1 11.6-1.4L20 8M4 16l2.4 2.4A7 7 0 0 0 18 17"
            />
          </svg>
        </button>
        <button
          id="open-share-card-btn"
          class="button button-secondary"
          type="button"
          :disabled="!currentTier"
          @click="openShareCardModal"
        >
          {{ previousDesign ? 'Share this' : 'Share' }}
          <svg class="action-icon" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M14 4h6v6M20 4l-9 9M10 5H5v14h14v-5" />
          </svg>
        </button>
      </div>
    </div>
  </component>
</template>
